import axios from "axios";
import { A3_DEFAULT_DB_SOURCE } from "../../constants/a3DbSource";

const API_URL = process.env.REACT_APP_API_URL;

const authHeaders = () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("No token");
  return { Authorization: `Bearer ${token}` };
};

export const listExpenseUserDocuments = async (params = {}) => {
  const res = await axios.get(`${API_URL}/api/expenses-user/documents`, {
    headers: authHeaders(),
    params,
  });
  return res.data;
};

export const getExpenseUserDocument = async (id) => {
  const res = await axios.get(`${API_URL}/api/expenses-user/documents/${id}`, {
    headers: authHeaders(),
  });
  return res.data;
};

export const createExpenseUserDocument = async (kind, file, opts = {}) => {
  const form = new FormData();
  form.append("kind", kind);
  form.append("file", file);
  if (opts.expenseUserNoteId != null && opts.expenseUserNoteId !== "") {
    form.append("expenseUserNoteId", String(opts.expenseUserNoteId));
  }
  const res = await axios.post(`${API_URL}/api/expenses-user/documents`, form, {
    headers: { ...authHeaders(), "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const patchExpenseUserDocument = async (id, body) => {
  const res = await axios.patch(
    `${API_URL}/api/expenses-user/documents/${id}`,
    body,
    {
      headers: {
        ...authHeaders(),
        "Content-Type": "application/json",
      },
    }
  );
  return res.data;
};

export const signExpenseUserDocument = async (id) => {
  const res = await axios.post(
    `${API_URL}/api/expenses-user/documents/${id}/sign`,
    {},
    { headers: authHeaders() }
  );
  return res.data;
};

export const signSupervisorExpenseUserDocument = async (id) => {
  const res = await axios.post(
    `${API_URL}/api/expenses-user/documents/${id}/sign-supervisor`,
    {},
    { headers: authHeaders() }
  );
  return res.data;
};

export const postExpenseUserDocumentA3 = async (id, body = {}) => {
  const { dbSource: dbFromCaller, ...rest } = body;
  const res = await axios.post(
    `${API_URL}/api/expenses-user/documents/${id}/post-a3`,
    { ...rest, dbSource: dbFromCaller ?? A3_DEFAULT_DB_SOURCE },
    { headers: authHeaders() }
  );
  return res.data;
};

export const deleteExpenseUserDocument = async (id) => {
  await axios.delete(`${API_URL}/api/expenses-user/documents/${id}`, {
    headers: authHeaders(),
  });
};

export const reExtractExpenseUserDocument = async (id) => {
  const res = await axios.post(
    `${API_URL}/api/expenses-user/documents/${id}/re-extract`,
    {},
    { headers: authHeaders() }
  );
  return res.data;
};

export const listExpenseUserDocumentCards = async (id) => {
  const res = await axios.get(
    `${API_URL}/api/expenses-user/documents/${id}/cards`,
    { headers: authHeaders() }
  );
  return res.data;
};
